import { Spinner } from "@chakra-ui/react";

const LoaderSpinner = () => {
  return (
    <Spinner
      thickness="4px"
      speed="0.65s"
      emptyColor="border.subtle"
      color="brand.accent"
      size="xl"
    />
  );
};

export default LoaderSpinner;
